import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';
import { NavLink } from 'react-router-dom';

import { getDashboardInspectionsTodayQueryOptions } from '@/queries/dashboard';
import { getWorkspaceRoute } from '@/utils/routes';

export const InspectionsToday = () => {
  const { data: response, isLoading: loading } = useQuery(getDashboardInspectionsTodayQueryOptions());
  const data = response?.data;

  const barColor = useMemo(() => {
    switch (data?.status) {
      case 'success':
        return 'rgb(95, 195, 96)';
      case 'warning':
        return 'rgb(249, 146, 38)';
      case 'danger':
        return 'rgb(227, 81, 77)';
    }
  }, [data?.status]);

  const options = {
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    colors: [barColor],
    plotOptions: {
      radialBar: {
        startAngle: -150,
        endAngle: 150,
        hollow: {
          size: '77%',
        },
        track: {
          background: '#ebe9f1',
          strokeWidth: '50%',
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            color: 'rgb(46, 57, 64)',
            fontSize: '20px',
            fontWeight: '700',
            offsetY: 5,
            formatter: (val: number) => (val ? val + '%' : '--'),
          },
        },
      },
    },
    stroke: {
      lineCap: 'round',
    },
  } satisfies ApexOptions;

  return data !== null ? (
    <>
      <div className="flex flex-col gap-2">
        <span className="text-xl leading-[30px] font-medium">Inspections Today</span>

        <div className="card-body p-0">
          <NavLink to={getWorkspaceRoute('/inspections/activity')}>
            <Chart options={options} series={[data?.percent || 0]} type="radialBar" height={203} />
          </NavLink>
        </div>

        <div className="flex text-center">
          <div className="w-1/2">
            <NavLink className="flex flex-col gap-[5px] p-[10px]" to={getWorkspaceRoute('/inspections/activity')}>
              <span className="text-default-text text-xl/[30px] font-bold">{loading ? '--' : data?.completed}</span>
              <span className="text-secondary-text text-sm/[21px] font-normal">Completed</span>
            </NavLink>
          </div>
          <div className="w-1/2">
            <NavLink className="flex flex-col gap-[5px] p-[10px]" to={getWorkspaceRoute('/inspections/activity')}>
              <span className="text-default-text text-xl/[30px] font-bold">{loading ? '--' : data?.pending}</span>
              <span className="text-secondary-text text-sm/[21px] font-normal">Pending</span>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  ) : null;
};
